import { IconButton, Stack } from "@mui/material"
import { useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect } from "react";
import { GrayTextField } from "../../utils/GrayTextField";

export const SearchField = ({onSearch, label, helperText, defaultText = '', ...props}) => {
    const [searchText, setSearchText] = useState('')

    const handleSearchTextChange = (newValue) => {
        setSearchText(newValue)
        onSearch(newValue)
    }

    useEffect(() => {
        setSearchText(defaultText || '')
    }, [defaultText])

    return (
        <>
            <Stack direction="row" sx={{alignItems: 'middle'}}>
                <GrayTextField
                    {...props}
                    label={label}
                    helperText={helperText}
                    variant="standard"
                    value={searchText}
                    onChange={(e) => handleSearchTextChange(e.target.value)}
                />
                <IconButton edge="start" sx={{mr: 0}} color="inherit">
                    {
                        searchText.length > 0
                        ?
                        <ClearIcon onClick={() => handleSearchTextChange('')} />
                        :
                        <SearchIcon />
                    }
                </IconButton>
            </Stack>
        </>
    )
}